import { Injectable } from '@angular/core';
import {
    ISimpleTableData,
} from '../../../../shared/components/simple-table-card/simple-table-card.component';
import { NoDataActionType, NoDataSourceType } from '../../../../shared/interfaces/no-data';

@Injectable({
    providedIn: 'root',
})
export class SimpleTableCardService {

    constructor() {}

    initializeSimpleDataCard(action: NoDataActionType) {
        let simpleDataTableData: ISimpleTableData = {
            title: '',
            isDataready: false,
            hasData: false,
            hasDrilldown: false,
            rowItems: [],
            headerItems: [],
            footerItems: [],
            noDataType: {
                action: action,
                searchTerm: '',
                componentTitle: '',
                inputSource: NoDataSourceType.table,
            },
            baseUrl: '',
            urlSegment: '',
            navFromUrl: '',
            hasAccess: false,
            queryParams: {},
            showCardControllers: true,
            showPercentages: false,
        };

        return simpleDataTableData;
    }    
}
